import { render } from "./BDropdownItem.vue?vue&type=template&id=ded2d9ba&scoped=true&ts=true"
import script from "./BDropdownItem.vue?vue&type=script&lang=ts"
export * from "./BDropdownItem.vue?vue&type=script&lang=ts"

import "./BDropdownItem.vue?vue&type=style&index=0&id=ded2d9ba&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ded2d9ba"]])

export default __exports__